module.exports = __webpack_public_path__ + "img/PDF.76b598c6.svg";